/** Endpoints /logements et /dpe. */

import { apiFetch } from "@/api/client";

export type LogementType = "maison" | "appartement";

export type LogementSummary = {
  id: string;
  title: string;
  type: LogementType;
  address_line: string | null;
  postal_code: string | null;
  city: string | null;
  construction_year: number | null;
  created_at: string;
  updated_at: string;
  latest_dpe_label: string | null;
  latest_dpe_state: "brouillon" | "calcule" | "archive" | null;
};

export type LogementDetail = LogementSummary & {
  department_code: string | null;
  altitude_band: string | null;
  floor: number | null;
  building_heating_type: string | null;
  building_ventilation_type: string | null;
  building_ecs_type: string | null;
  // Données fiscales du foyer occupant (optionnel — F-TRAV-005)
  household_size: number | null;
  tax_reference_income_eur: number | null;
};

export type LogementCreatePayload = {
  title: string;
  type: LogementType;
  address_line?: string;
  postal_code?: string;
  city?: string;
  department_code?: string;
  construction_year?: number;
  floor?: number;
  building_heating_type?: "individuel" | "collectif";
  building_ventilation_type?: "individuelle" | "collective";
  building_ecs_type?: "individuelle" | "collective";
  household_size?: number | null;
  tax_reference_income_eur?: number | null;
};

export function listLogements() {
  return apiFetch<LogementSummary[]>("/logements");
}

export function getLogement(id: string) {
  return apiFetch<LogementDetail>(`/logements/${id}`);
}

export function createLogement(payload: LogementCreatePayload) {
  return apiFetch<LogementDetail>("/logements", { method: "POST", body: payload });
}

export function updateLogement(id: string, payload: Partial<LogementCreatePayload>) {
  return apiFetch<LogementDetail>(`/logements/${id}`, { method: "PATCH", body: payload });
}

export function deleteLogement(id: string) {
  return apiFetch<void>(`/logements/${id}`, { method: "DELETE" });
}
